/**
 * @generated SignedSource<<da6753c561036a3cc1f5a3cbab00a317>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FooterRenderer195BadPattern$data = {
  readonly " $fragmentSpreads": FragmentRefs<"IssueCreateFooter101BadPattern">;
  readonly " $fragmentType": "FooterRenderer195BadPattern";
};
export type FooterRenderer195BadPattern$key = {
  readonly " $data"?: FooterRenderer195BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"FooterRenderer195BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "FooterRenderer195BadPattern",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "IssueCreateFooter101BadPattern"
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "62341820b0dab389e045ea1ef3abe9c8";

export default node;
